import { emptyRules, } from "@shared";
import { addLookedUpMembers } from "../members";
export class ChatDetailsState {
    chatId;
    timestamp;
    members;
    lapsedMembers;
    blockedUsers;
    invitedUsers;
    pinnedMessages;
    bots;
    webhooks;
    rules;
    moreMembersAfter;
    constructor(chatId, timestamp, members, lapsedMembers, blockedUsers, invitedUsers, pinnedMessages, bots, webhooks, rules = emptyRules(), 
    // Set if not all of the members are held, to the user id after which those not in the
    // first page start
    moreMembersAfter = undefined) {
        this.chatId = chatId;
        this.timestamp = timestamp;
        this.members = members;
        this.lapsedMembers = lapsedMembers;
        this.blockedUsers = blockedUsers;
        this.invitedUsers = invitedUsers;
        this.pinnedMessages = pinnedMessages;
        this.bots = bots;
        this.webhooks = webhooks;
        this.rules = rules;
        this.moreMembersAfter = moreMembersAfter;
    }
    // These details with members added who have been looked up, or undefined if there are none to
    // add (see `addLookedUpMembers`)
    withLookedUpMembers(found, asOf) {
        const added = addLookedUpMembers(this, found, asOf);
        if (added === undefined) {
            return undefined;
        }
        return new ChatDetailsState(this.chatId, this.timestamp, added.members, added.lapsedMembers, this.blockedUsers, this.invitedUsers, this.pinnedMessages, this.bots, this.webhooks, this.rules, this.moreMembersAfter);
    }
}
